import Vue from 'vue'
import moment from 'vue-moment'
import App from './App.vue'
import VueScrollTo, { options as vueScrollToOptions } from './plugins/scrollto'
import Toasted, { options as vueToastedOptions } from './plugins/toast'
import router from '@/router/index'
import './sass/app.scss'
import './utils/viewport'
import store from './store'
import i18n from './plugins/i18n'
import Breakpoints from '@/plugins/breakpoints'
import * as Sentry from '@sentry/vue'
// eslint-disable-next-line
import VueMask from 'v-mask'
import { ProjectIsGPT } from '@/utils/project'
if (process.env.VUE_APP_PRODUCTION_MODE === '1') {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_API_SENTRY,
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracePropagationTargets: ['builder', window.location.origin, /^\//],
      }),
      new Sentry.Replay(),
    ],
    tracingOptions: {
      trackComponents: true,
      timeout: 500,
      hooks: ['activate', 'create', 'destroy', 'mount', 'update'],
    },
    tracesSampleRate: 1.0,
  })
}
const projectName = ProjectIsGPT() ? 'GPT' : 'CRM'
console.log(`%c${projectName}`, 'color: green')

Vue.config.productionTip = false
/* eslint-disable vue/require-name-property */
Vue.use(moment)
Vue.use(VueScrollTo, vueScrollToOptions)
Vue.use(Toasted, vueToastedOptions)
Vue.use(VueMask)
Vue.use(Breakpoints)

/* eslint-disable */
export default new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
